import html2canvas from "html2canvas";
import moment from "moment";
import { jsPDF } from "jspdf";
import logo from "../../assets/images/logo.png";
import { paymentMethods } from "../../data";
import { formatNumberWithCommas, formattedDate } from "../../helpers";
import { convertUtcToLocalTime } from "../../helpers/exportHelpers";

const getStatusLabel = (statusId) => {
  switch (statusId) {
    case 1:
      return "Confirmed";
    case 2:
      return "Cancelled";
    case 3:
      return "Pending";
    case 4:
      return "Completed";
    default:
      return "--";
  }
};

const getPaymentStatus = (statusId) => {
  switch (statusId) {
    case 1:
      return "Received";
    case 2:
      return "Refunded";
    default:
      return "--";
  }
};

export const exportDetailsToPDF = (bookingDetails) => {
  // Get primary player details
  const primaryPlayer = bookingDetails?.bookingPlayers?.find(
    (player) => player?.isPrimary
  );

  // Create a style element for our CSS classes
  const styleElement = document.createElement("style");
  styleElement.textContent = `
      .pdf-container {
        width: 210mm;
        padding: 20px;
        font-family: Arial, sans-serif;
        position: absolute;
        left: -9999px;
      }
      .logo-section {
        text-align: center;
        margin-bottom: 20px;
      }
      .logo-image {
        width: 190px;
        height: 40px;
      }
      .reference-section {
        margin-bottom: 20px;
      }
      .reference-title {
        color: var(--highlight-text);
        font-size: 20px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 14px;
        margin-top: 10px;
      }
      .details-section {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width:1000px;
        gap: 10px;
        margin-bottom: 20px;
        font-size: 12px;
        }
        .detail-list-wrapper{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 4px;
        width: 200mm;
        
        box-sizing: border-box;
      }
       
        .detail-list-wrapper li{
        flex:1;

       width: calc(50% - 4px);
        margin-bottom: 8px;
      }
      .detail-item {
        margin: 0;
    
        
        line-height: 20px;
        letter-spacing: -0.25px;
        display: flex;
        align-items: center;
       
        font-family: "NotoSans-semibold";
        font-size: 15px;
        margin-bottom: 10px;
      }
         .detail-item strong{
        color: var(--highlight-text);
        font-weight: 600;
        line-height: 20px;
        letter-spacing: -0.25px;
        font-family: "NotoSans-semibold";
        display: inline-block;
        min-width: 80px;
      }
        .detail-item span{
        color: var(--dusky-steel);
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.25px;
        font-family: "NotoSans-regular";
        display: inline-block;
        min-width: 80px;
        }
      .divider {
        border: none;
        border-top: 1px solid #ccc;
        margin: 20px 0;
      }
      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: var(--highlight-text);
        margin-bottom: 10px;
      }
      .data-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 9px;
        margin-bottom: 20px;
      }
      .table-header {
        // background-color: #3A86DD;
        background-color: transparent;
        color: var(--highlight-text);
        font-weight: 600;
        font-size: 14px;
        

      }
       thead  .table-cell {
        padding: 8px;
        text-align: left;
        
        border-bottom: 1px solid #9EA2B3;
        border-top: 1px solid #9EA2B3;
        font-size: 14px;
        font-weight: 600;
        color: var(--highlight-text);
      }
     tbody .table-cell {
        padding: 8px;
        text-align: left;
        
        font-size: 14px;
        font-weight: 400;
        color: var(--dusky-steel);
      }
      .empty-row {
        text-align: center;
        padding: 8px;
      }
        .right-label >strong{
        text-align: left;
        width: 144px !important;
        white-space: nowrap;
        }
    `;
  document.head.appendChild(styleElement);

  // Create an HTML container for our content
  const container = document.createElement("div");
  container.className = "pdf-container";
  document.body.appendChild(container);

  // Create HTML content with classes
  const content = `
      <div class="logo-section">
        <img class="logo-image" src="${logo}" alt="Logo">
      </div>
      
      <div class="reference-section">
        <h1 class="reference-title">
          Reference ID: ${bookingDetails?.bookingNo
            ?.split("-")
            ?.slice(1)
            .join("-")}
        </h1>
      </div>
      
      <div class="details-section">
      <ul class="detail-list-wrapper">
      
      <li>
       <p class="detail-item"><strong>Name:</strong> <span> ${
         primaryPlayer?.playerFullName || "--"
       }</span></p>
        <p class="detail-item"><strong>Phone:</strong> <span> ${
          primaryPlayer?.playerCellNumber || "--"
        }</span></p>
        <p class="detail-item"><strong>Email:</strong><span>${
          primaryPlayer?.playerEmail || "--"
        }</span> </p>
        <p class="detail-item"><strong>Location:</strong> <span> ${
          bookingDetails?.locationName || "--"
        }</span></p>
        <p class="detail-item"><strong>Court:</strong> <span> ${
          bookingDetails?.courtName || "--"
        }</span></p>
        <p class="detail-item"><strong>Address:</strong> <span> ${
          bookingDetails?.locationAddress || "--"
        }</span></p>
      </li>
 <li>
 
  
        <p class="detail-item right-label">
            <strong>Date:</strong> 
            <span class="d-flex">           
              <span>
                ${formattedDate(bookingDetails?.bookingDate)}
              </span>              
            </span>
          </p>   
          <p class="detail-item right-label">
            <strong>Time:</strong> 
            <span class="d-flex">
              <span>
                ${moment(bookingDetails?.bookingStartTime, "HH:mm:ss").format("hh:mm A")} - ${moment(bookingDetails?.bookingEndTime, "HH:mm:ss").format("hh:mm A")}
              </span>
            </span>
          </p>          
          ${
           bookingDetails?.bookingDiscountAmount > 0 ? 
            `<p class="detail-item right-label">
                <strong>Discount Amount:</strong> 
                <span>
                  Rs. ${formatNumberWithCommas(bookingDetails?.bookingDiscountAmount)}
                </span>
              </p>`
            : ""
         }
         
      
       
          <p class="detail-item right-label"><strong>Amount:</strong> <span> Rs. ${formatNumberWithCommas(
          bookingDetails?.bookingNetAmount
        )}</span></p> 
         <p class="detail-item right-label"><strong>Collected Amount:</strong> <span> Rs. ${
           formatNumberWithCommas(bookingDetails?.bookingCollectedAmount) || "0"
         }</span></p>
        
        <p class="detail-item right-label"><strong>Status:</strong> <span> ${getStatusLabel(
          bookingDetails?.bookingStatusId
        )}</span></p>
          
 </li>
      </ul>
       
       
      </div>

        <div>
        <h2 class="section-title">Slot Details</h2>
      </div>
      
      <div>
        <table class="data-table">
          <thead>
            <tr class="table-header">
              <th class="table-cell">Slot Time</th>
              <th class="table-cell">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${
              bookingDetails?.bookingBreakdowns
                ?.map(
                  (slot) => `
              <tr>
                <td class="table-cell">
                  ${moment(slot?.bookingStartTime, "HH:mm:ss").format("hh:mm A")} - ${moment(slot?.bookingEndTime, "HH:mm:ss").format("hh:mm A")}
                </td>
                <td class="table-cell">
                  Rs. ${formatNumberWithCommas(slot?.charges)}
                </td>
              </tr>
            `
                )
                .join("") ||
              `<tr><td class="empty-row" colspan="2">No slot details available</td></tr>`
            }
          </tbody>
        </table>
      </div>
      
      ${
        bookingDetails?.bookingPayments?.length > 0
          ? `
          <hr class="divider">
          
          <div>
            <h2 class="section-title">Payment Details</h2>
          </div>
          
          <div>
            <table class="data-table">
              <thead>
                <tr class="table-header">
                  <th class="table-cell">Payment ID</th>
                  <th class="table-cell">Date</th>
                  <th class="table-cell">Amount</th>
                  <th class="table-cell">Payment Mode</th>
                  <th class="table-cell">Payment Status</th>
                </tr>
              </thead>
              <tbody>
                ${bookingDetails?.bookingPayments
                  ?.map(
                    (payment) => `
                  <tr>
                    <td class="table-cell">
                      ${payment?.payNo?.split("-")?.slice(1).join("-")}
                    </td>
                    <td class="table-cell">
                      ${formattedDate(
                        convertUtcToLocalTime(payment?.paymentDate)
                      )} ${moment(
                      convertUtcToLocalTime(payment?.paymentDate)
                    ).format("hh:mm A")}
                    </td>
                    <td class="table-cell">
                      Rs. ${formatNumberWithCommas(payment?.amount)}
                    </td>

                    <td class="table-cell">
                      ${
                        paymentMethods?.find(
                          (item) => item?.value === payment?.paymentModeId
                        )?.label || "--"
                      }
                    </td>
                    <td class="table-cell">
                      ${getPaymentStatus(payment?.paymentStatusId)}
                    </td>
                  </tr>
                `
                  )
                  .join("")}
              </tbody>
            </table>
          </div>
        `
          : "" // Don't render anything if there are no payments
      }
      
    
    `;

  // Set the innerHTML of the container
  container.innerHTML = content;

  // Function to handle PDF generation after HTML is rendered
  const generatePDF = async () => {
    try {
      // Use html2canvas to convert the HTML to canvas
      const canvas = await html2canvas(container, {
        scale: 2, // Higher scale for better quality
        useCORS: true, // Enable CORS for images
        logging: false,
      });

      // Create PDF
      const pdf = new jsPDF("p", "mm", "a4");
      const imgData = canvas.toDataURL("image/png");

      // Calculate the proper scaling
      const imgWidth = 210; // A4 width in mm minus margins
      const pageHeight = 297; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      // Add first page
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add more pages if content is longer than one page
      while (heightLeft > 0) {
        position = -pageHeight * (imgHeight / heightLeft);
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Save the PDF
      pdf.save(
        `booking_details_${bookingDetails?.bookingNo
          ?.split("-")
          ?.slice(1)
          .join("-")}.pdf`
      );

      // Clean up
      document.body.removeChild(container);
      document.head.removeChild(styleElement);
    } catch (error) {
      console.error("Error generating PDF:", error);
      document.body.removeChild(container);
      document.head.removeChild(styleElement);
    }
  };

  // Generate the PDF
  generatePDF();
};
